<template lang="html">
  <prt-modal class="prt-loader-modal" :show="show">
    <div class="card">
      <prt-loader :duration="3" infinite :size="48" />
      <h1>{{label}}</h1>
    </div>
  </prt-modal>
</template>

<script>
import PrtLoader from './PrtLoader.vue';
import PrtModal from './PrtModal.vue';

export default {
  components: {
    PrtLoader,
    PrtModal,
  },
  props: {
    label: String,
    show: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-loader-modal
    display: flex
    justify-content: center
    align-items: flex-end

    &.fade-enter-active .card,
    &.fade-leave-active .card
      transition: transform 200ms ease-out

    &.fade-enter .card,
    &.fade-leave-to .card
      transform: translateY(100%)

    .card
      background-color: white
      border-top-left-radius: 4px
      border-top-right-radius: 4px
      box-shadow: 0 2px 4px black-12
      width: 100%
      padding: 24px
      box-sizing: border-box
      text-align: center

      .prt-loader
        margin: 0 auto 12px auto

      h1
        font-size: 1rem
        font-weight: normal
        margin: 0
</style>
